module.exports = __webpack_public_path__ + "static/media/logo.53d91d81.svg";